import { Outlet } from "react-router-dom";

const WalletPage = () => {
    return (
        <Outlet />
    );
};

export default WalletPage;
